export class TempActionRequestDto {
    requestId?: number;
    requestIssueId?: number;
    requestIssueTypeId?: number;
    comment?: string = '';
    attachments?: File[];
    createdBy !: string;
    modifiedBy?: string;
    assetName?: string;
}